/// <reference path="../../TimeTracking/PurchaseOrderLines/PurchaseOrderLinesDialog.ts" />

import { PurchaseOrderLinesDialog } from "@/TimeTracking/PurchaseOrderLines/PurchaseOrderLinesDialog";
import { Decorators } from "@serenity-is/corelib";


@Decorators.registerClass("Profis.Projects.ProjectPurchaseOrderDialog")
export class ProjectPurchaseOrderDialog extends PurchaseOrderLinesDialog {
    updateInterface() {
        super.updateInterface();
        this.form.ProjectId.getGridField().hide();
    }
}
